module.exports = __webpack_public_path__ + "static/media/prove_screenshot.abeec2bc.webp";